import React, {useEffect} from 'react'
import { getProviders, signIn } from "next-auth/react"
import { getServerSession } from "next-auth/next"
import { authOptions } from "../pages/api/auth/[...nextauth]";
import {appVersion, AUTH_STATUSES, routes} from "utils/constants";
import {useFirebaseSession} from "utils/hooks/useFirebaseSession";
import {Logo, Spinner, Error} from "components/common";
import Head from "next/head";
import styled from "styled-components";
import {useRouter} from "next/router";

export default function SignIn({ providers }) {
  const router = useRouter()

  const error = router.query.error

  const { status } = useFirebaseSession();

  const isLoading = status === AUTH_STATUSES.LOADING;

  useEffect(() => {
    if (status === AUTH_STATUSES.AUTHENTICATED) {
      router.push(routes.home)
    }
  }, [status])

  return (
    <>
      <Head>
        <title>SnorkelBob Login</title>
      </Head>
      <Wrapper>
        <AppVersion>Version {appVersion}</AppVersion>
        {isLoading && <Spinner />}
        <LeftPanel>
          <Logo
            src="/images/sb-logo.png"
            alt=""
            height="70px"
          />
          <h3>Welcome to Snorkel Bob&#39;s Rental App</h3>
          {Object.values(providers).map((provider, index) => (
            <ButtonWrapper key={`${index}-${provider.name}`}>
              <AuthButton onClick={() => signIn(provider.id)}>
        <span>
          <img alt="google logo" src="/google.svg" width="20px" height="20px" />
        </span>
                Login with {provider.name}
              </AuthButton>
              {error && error !== "" && <Error>{error}</Error>}
            </ButtonWrapper>
          ))}
        </LeftPanel>
        <RightPanel>
          <img src="/images/snorkel-home-page.jpeg" alt="" />
        </RightPanel>
      </Wrapper>
    </>
  )
}

export const Wrapper = styled.div`
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100%;
  font-family: 'Overpass', sans-serif;
  display: flex;
  .lds-ripple {
    position: absolute;
    top: calc(50% - 36px);
    left: calc(50% - 36px);
    z-index: 40000;
  }
`;

export const LeftPanel = styled.div`
  height: 100vh;
  width: 50%;
  font-family: 'Overpass', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
`;

export const RightPanel = styled.div`
  height: 100vh;
  width: 50%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 2rem;
  position: relative;
`;

export const AuthButton = styled.button`
  cursor: pointer;
  font-family: 'Overpass', sans-serif;
  position: relative;
  width: 300px;
  height: 50px;
  background: #4885ed;
  border: none;
  border-radius: 6px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 180%;
  text-align: center;
  color: white;
  outline: none;
  &:hover {
    box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
  }
  &:active {
    background-color: #3367d6;
  }
  span {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 48px;
    height: 48px;
    background: white;
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const AppVersion = styled.div`
  position: fixed;
  bottom: 0px;
  right: 20px;
  background-color: white;
  padding: 2px 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;


export async function getServerSideProps(context) {
  const session = await getServerSession(context.req, context.res, authOptions);
  if (session) {
    return { redirect: { destination: routes.home } };
  }
  const providers = await getProviders();

  return {
    props: { providers: providers ?? [] },
  }
}
